import { shallowEqual, useSelector } from 'react-redux';
import { IReduxState } from 'store/reducers';

export default function useReduxSelector<T>(
  selector: (state: IReduxState) => T,
  equalityFn: (left: T, right: T) => boolean = shallowEqual
) {
  return useSelector<IReduxState, T>(selector, equalityFn);
}
